import { render, staticRenderFns } from "./AddPurchaseOrder.vue?vue&type=template&id=395e6420&scoped=true&"
import script from "./AddPurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./AddPurchaseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395e6420",
  null
  
)

export default component.exports